/**
 * @generated SignedSource<<bba8f04573f8cc2476ac20fe7544388b>>
 * @relayHash 75458db796a70398a51779635b8c2433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 25f1b41bf2ec626b2ef8a3ffd2c0b9de551e7d64a42397225ada96dd8440972e

import type { ConcreteRequest } from 'relay-runtime';
export type virtualServiceAgentHeaderDumbHelpCenterQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type virtualServiceAgentHeaderDumbHelpCenterQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly virtualAgentEnabled: boolean | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
  readonly virtualAgent: {
    readonly virtualAgentAvailability: boolean | null;
  } | null;
};
export type virtualServiceAgentHeaderDumbHelpCenterQuery = {
  response: virtualServiceAgentHeaderDumbHelpCenterQuery$data;
  variables: virtualServiceAgentHeaderDumbHelpCenterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "virtualAgentEnabled"
    }
  ],
  "type": "HelpCenter"
},
v5 = {
  "concreteType": "VirtualAgentQueryApi",
  "kind": "LinkedField",
  "name": "virtualAgent",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "containerId",
          "variableName": "helpCenterAri"
        }
      ],
      "kind": "ScalarField",
      "name": "virtualAgentAvailability"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      },
      (v5/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      },
      (v5/*: any*/)
    ]
  },
  "params": {
    "id": "25f1b41bf2ec626b2ef8a3ffd2c0b9de551e7d64a42397225ada96dd8440972e",
    "metadata": {},
    "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e1e97ac63a001c8e98b3e9b2c21c9fc4";

export default node;
